import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import Login from "./pages/Auth/login";
import VerifyEmail from "./pages/Auth/VerifyEmail";
import ChatbotInterface from "./pages/Dashboard/ChatbotInteface";
import Overview from "./pages/Dashboard/overview";
import PrivateRoute from "./components/common/PrivateRoute";
import Dashboard from "./pages/Dashboard/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "./services/oprations/authAPI";
import PasswordManagement from "./pages/Settings/PasswordManagement";
import ProfileManagement from "./pages/Settings/ProfileManagement";
import UserManagement from "./pages/Settings/Admin/UserManagement";
import AddUserForm from "./pages/Settings/Admin/AddUserForm";
import PatientManagement from "./pages/Dashboard/PatientManagement";
import DoctorManagement from "./pages/Dashboard/DoctorManagement";
import Voicebot from "./pages/Dashboard/Voicebot";
import DocumentAnalysis from "./pages/Dashboard/DocumentAnalysis";
import PatientDetails from "./pages/Dashboard/Doctor/PatientDetails";
import DoctorAI from "./pages/Home/DoctorAI";
import Contact from "./components/Home/Contact";
import Privacy from "./components/Home/Privacy";
import AboutPage from "./components/Home/AboutUS";
import Signup from "./pages/Auth/Signup";
const RedirectIfLoggedIn = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? <Navigate to="/dashboard" replace /> : children;
};

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.profile);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     dispatch(getUserDetails()).then((success) => {
  //       if (!success) {
  //         navigate("/");
  //       }
  //     });
  //   }
  // }, [dispatch, ]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    // 👇 CHECK FOR BOTH TOKEN AND IF USER IS MISSING
    if (token && !user) {
      dispatch(getUserDetails()).then((success) => {
        if (!success) {
          navigate("/");
        }
      });
    }
  }, [dispatch, navigate, user]);

  return (
    <Routes>
 
      <Route path="/"  element={<DoctorAI />} />
      {/* Public DoctorAI homepage */}
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/about-us" element={<AboutPage />} />
      {/* Auth-related routes */}
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/sign-up" element={<Signup/>} />
      <Route path="voicebot" element={<Voicebot />} />

      <Route
        path="/login"
        element={
          <RedirectIfLoggedIn>
            <Login />
          </RedirectIfLoggedIn>
        }
      />
      {/* Dashboard routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      >
        {/* child routes inside Dashboard */}
        <Route index element={<Overview />} />
        <Route path="voicebot" element={<Voicebot />} />
        <Route path="chatbot" element={<ChatbotInterface />} />
        <Route path="document-analysis" element={<DocumentAnalysis />} />
        <Route path="doctor-management" element={<DoctorManagement />} />
        <Route
          path="doctor-management/patient-details/:id"
          element={<PatientDetails />}
        />

        <Route path="patient-management" element={<PatientManagement />} />
        <Route path="settings">
          <Route path="profile-management" element={<ProfileManagement />} />
          <Route path="password-management" element={<PasswordManagement />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="user-management/add-user" element={<AddUserForm />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
